import { IPluginFormControl, IPluginPresenter, PluginFieldType } from '@makyoapp/makyo-sdk/models/Plugins'
import { TextField } from '@makyoapp/makyo-tw-ui'

interface PluginFormControlProps {
  language: string
  control: IPluginFormControl
  plugin: IPluginPresenter
  value: string
  onChange: (value: string) => void
  labelStyle?: React.CSSProperties
  error?: string
}

export const PluginFormControl = ({
  language,
  control,
  plugin,
  value,
  onChange,
  labelStyle,
  error,
}: PluginFormControlProps) => {
  // ========================= design =========================

  const fieldStyle = {
    width: '100%',
  }

  // ========================= field =========================

  // get plugin field control
  const fieldControl = plugin._Frontend._Controls.find((c) => c._Key === control._Key)
  if (!fieldControl) return null

  const fieldLabel = fieldControl._Label[language] ?? fieldControl._Label['en']
  const fieldId = `${fieldLabel}-${control._Key}`

  switch (fieldControl._Type) {
    case PluginFieldType.Password: {
      return (
        <TextField
          id={fieldId}
          key={fieldId}
          style={fieldStyle}
          required
          type='password'
          label={fieldLabel}
          labelStyle={labelStyle}
          value={value}
          onChange={(e) => {
            onChange(e.target.value)
          }}
          onClear={() => {
            onChange('')
          }}
          error={error}
        />
      )
    }

    case PluginFieldType.Email: {
      return (
        <TextField
          key={fieldId}
          id={fieldId}
          style={fieldStyle}
          required
          type='email'
          label={fieldLabel}
          labelStyle={labelStyle}
          value={value}
          onChange={(e) => {
            onChange(e.target.value)
          }}
          onClear={() => {
            onChange('')
          }}
          error={error}
        />
      )
    }

    // @ts-ignore
    case 'link': {
      return (
        <a
          className='cursor-pointer'
          style={{
            font: `var(--field-label-font)`,
            color: 'var(--field-color-accent)',
          }}
        >
          {fieldLabel}
        </a>
      )
    }

    default:
      return (
        <TextField
          id={fieldId}
          key={fieldId}
          style={fieldStyle}
          required
          type='text'
          label={fieldLabel}
          labelStyle={labelStyle}
          value={value}
          onChange={(e) => {
            onChange(e.currentTarget.value)
          }}
          onClear={() => {
            onChange('')
          }}
          error={error}
        />
      )
  }
}
